export default __webpack_public_path__ + "static/media/security04.b490ffa8.png";